__turbopack_context__.v({
  "checkbox": "Explorer-module__0yi9oq__checkbox",
  "chevron": "Explorer-module__0yi9oq__chevron",
  "explorer": "Explorer-module__0yi9oq__explorer",
  "file": "Explorer-module__0yi9oq__file",
  "files": "Explorer-module__0yi9oq__files",
  "heading": "Explorer-module__0yi9oq__heading",
  "title": "Explorer-module__0yi9oq__title",
});
